import { ConfirmationModal } from "../ConfirmationModal/ConfirmationModal";

type TDiscardChangesModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  title?: string;
  content?: string;
};

export function DiscardChangesModal({ isOpen, onClose, onDiscard, title, content }: TDiscardChangesModalProps) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onDiscard}
      title={title || "Discard changes?"}
      content={content || "You have unsaved changes. If you leave now, your progress will be lost."}
      dangerConfirm
      confirmButtonText="Discard"
    />
  );
}
